import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import RecordBetsReportUsers from 'views/customers/reports/betsReport/recordTableReport'; // Importing a specific report view
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record bets report view.
 * @extends JetView
 */
export default class recordBetsReportView extends JetView {
    /**
     * Configures the layout of the record bets report view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label', // Label component
                            label: _('Detalles del Ticket'), // Translated label text
                            width: 150, // Width of the label
                        },
                    ],
                },
                RecordBetsReportUsers, // Including the RecordBetsReportUsers component
            ],
        };

        return {
            width: screen !== 'small' ? 500 : 230, // Conditional width based on screen size
            height: screen !== 'small' ? 300 : 230, // Conditional height based on screen size
            type: 'wide', // Type of layout
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
